import React from "react";
import PropTypes from "prop-types";
import "../css/GenericPage.css";
import { withStore, withScreenCheck } from "../hoc";
import Navbar from "../components/Navbar";
import Body from "../components/Body";
import Footer from "../components/Footer";
/**
 * GenericPage
 */
class GenericPage extends React.Component {
  static displayName = "GenericPage";
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "GenericPage";
  }

  /**
   * @override
   */
  render() {
    return (
      <div className="GenericPage">
        <Navbar {...this.props} />
        <Body {...this.props}>
          <div className={`${this.className}__card`}>
            <div className={`${this.className}__title`}>
              {this.props.currentPage.Title}
            </div>
            <div
              className={`${this.className}__content`}
              dangerouslySetInnerHTML={{
                __html: this.props.currentPage.Content,
              }}
            />
          </div>
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(GenericPage));



// WEBPACK FOOTER //
// ./src/pages/GenericPage.js